import { objectToQueryQuestionMark } from "@utils/url";

export const getSweeprOtcUserRoute = () =>
    `${process.env.API_URL}sweepr/otc/user${objectToQueryQuestionMark({
        systemId: process.env.SWEEPR_SYSTEM_ID ?? "",
    })}`;
